import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetWealthAdvisorDetailsUseCase extends BaseUseCase {
    constructor(WealthAdvisorDetailsRep) {
        super();
        this.WealthAdvisorDetailsRep = WealthAdvisorDetailsRep;
    }
    async fetchResult(req) {
        return await this.WealthAdvisorDetailsRep.wealthAdvisorData(req);
    }
}
export default GetWealthAdvisorDetailsUseCase;
